<!--
 * @Author: DY
 * @Date: 2020-07-23 14:34:30
 * @LastEditTime: 2020-09-12 12:15:17
 * @LastEditors: name
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_dev\src\views\salesTerminal\abnormalProduction\index.vue
-->
<template>
    <div class="abnormalProduction">
        <van-nav-bar
            title=""
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        >
            <template #title>
                <van-tabs
                    v-model="activeIndex"
                    animated
                    @click="toggletab"
                >
                    <template v-for="(item,index) in navData">
                        <van-tab
                            :key="index"
                            :title="item.name"
                        >
                        </van-tab>
                    </template>
                </van-tabs>
            </template>
        </van-nav-bar>
        <section class="main-wrapper">
            <div class="box-wrapper">
                <component :is="currentView"></component>
            </div>
        </section>
    </div>
</template>

<script>
// 异常打料
import abnormal from './abnormal.vue';
// 实时库存
import stock from './stock.vue';
export default {
    // 异常打料
    name: 'abnormal-production',
    components: {
        abnormal,
        stock,
    },
    data() {
        return {
            currentView: '',
            activeIndex: 0,
            navData: [],
        };
    },
    created() {
        this.navData = [];
        if (this.$route.params.type === 'abnormalPunching') {
            this.navData = [
                {
                    name: '异常打料',
                    value: 'abnormal',
                },
            ];
            this.currentView = 'abnormal';
        } else if (this.$route.params.type === 'realTimeMonitoring') {
            this.navData = [
                {
                    name: '实时库存',
                    value: 'stock',
                },
            ];
            this.currentView = 'stock';
        } else {
            this.navData = [
                {
                    name: '异常打料',
                    value: 'abnormal',
                }, {
                    name: '实时库存',
                    value: 'stock',
                },
            ];
            this.currentView = 'abnormal';
        }
    },
    methods: {
        toggletab(index) {
            this.currentView = this.navData[index].value;
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="stylus">
.abnormalProduction
    width 100%
    height 100%
    display flex
    flex-direction column
    .van-nav-bar
        display flex
        .van-nav-bar__title
            max-width 75%
            .van-tabs
                .van-tabs__nav
                            background rgba(0,0,0,0)
                    .van-tab
                        flex-basis auto !important
                        font-size 14rpx
                        margin 0 6rpx
                        line-height 44rpx
                        color rgba(240,240,240,0.5)
                        transition 0.2s
                        &.van-tab--active
                            font-size 16rpx
                            line-height 44rpx
                            color #FFFFFF
                        .van-tab__text
                            white-space nowrap
                    .van-tabs__line
                        display none
                .van-tabs__wrap
                    &:after
                        display none
        .van-ellipsis
            white-space normal
        .van-nav-bar__right
            width 0
    .main-wrapper
        flex 1
        overflow hidden
        .box-wrapper
            height 100%
            overflow-y auto
</style>